export default "__VITE_ASSET__Dijo_8kz__"